import {
    Body1,
    Flex,
    IconCheckCircle,
    IconMedication,
    IconNumbers,
    Stack,
} from '@phx/design-system';
import { useTranslation } from 'react-i18next';

import { getFragment } from '../../../graphql';
import type { PriorAuthorizationInfoFragment } from '../../../graphql/generated/graphql';
import { formatDateString } from '../../../util';
import { ConditionalComponent } from '../../utility/ConditionalComponent';

export const PriorAuthDetailsList = ({
    priorAuthorization,
}: {
    priorAuthorization: PriorAuthorizationInfoFragment;
}) => {
    const { t } = useTranslation();
    const { quantity, medication, effectiveDates } = priorAuthorization;

    const { id: ndc } = getFragment(medication);
    const { effectiveTo } = getFragment(effectiveDates);
    const paValidDate = effectiveTo ? formatDateString(effectiveTo) : null;

    return (
        <Stack gap="sm">
            <ConditionalComponent condition={!!quantity}>
                <Flex gap="xs">
                    <IconMedication color="secondary" />
                    <Body1>
                        {t('orderDetails.quantity', {
                            quantity,
                        })}
                    </Body1>
                </Flex>
            </ConditionalComponent>
            <Flex gap="xs">
                <IconNumbers color="secondary" />
                <Body1>
                    {t('order.ndc', {
                        ndc,
                    })}
                </Body1>
            </Flex>
            <ConditionalComponent condition={!!paValidDate}>
                <Flex gap="xs">
                    <IconCheckCircle color="secondary" />
                    <Body1>
                        {t('order.paValid', {
                            paValidDate,
                        })}
                    </Body1>
                </Flex>
            </ConditionalComponent>
        </Stack>
    );
};
